<template>
    <div>
        <div class="form-group" v-if="item.addon_product_id && !item.locked">
            <input type="text" class="form-control" placeholder="Enter desired text"
                v-model="item.addon_item_comment" @input="personalisationChanged"
                :maxlength="item.input_max_length" />
        </div>
        <div class="table-row" v-if="!item.locked && item.matrix_product_id">
            <div class="table-cell">
                <div class="styled-dropdown mb-3" v-if="Object.keys(sizes).length > 0">
                    <select v-on:change="getBasketOptions(item)" v-model="productSizeId">
                        <option :value="null" :disabled="true">Please Select Size</option>
                        <option v-for="size in sizes" :disabled="!size.id" v-bind:key="size.id"
                            :value="size.id">
                            {{ size.name }}
                        </option>
                    </select>
                    <i class="fas fa-chevron-down"></i>
                </div>
                <div class="styled-dropdown mb-3" v-if="Object.keys(lengths).length > 0">
                    <select v-on:change="getBasketOptions(item)" v-model="productLengthId"
                        :disabled="Object.keys(lengths).length > 1 && productSizeId == null && Object.keys(sizes).length > 0">
                        <option :value="null" :disabled="true">Please Select Length</option>
                        <option v-for="length in lengths" v-bind:key="length.id"
                            :value="length.id">
                            {{ length.name }}
                        </option>
                    </select>
                    <i class="fas fa-chevron-down"></i>
                </div>
                <div class="styled-dropdown mb-3" v-if="Object.keys(colours).length > 1">
                    <select v-on:change="getBasketOptions(item)" v-model="productColourId"
                        :disabled="(Object.keys(colours).length > 1 && productSizeId == null && Object.keys(sizes).length > 0)
                        || (Object.keys(lengths).length > 1 && productLengthId == null)">
                        <option :value="null" :disabled="true">Please Select Colour</option>
                        <option v-for="colour in colours" v-bind:key="colour.id"
                            :value="colour.id">
                            {{ colour.name }}
                        </option>
                    </select>
                    <i class="fas fa-chevron-down"></i>
                </div>
                <div class="styled-dropdown mb-3" v-if="Object.keys(flavours).length > 0">
                    <select v-on:change="getBasketOptions(item)" v-model="productFlavourId"
                        :disabled="(Object.keys(flavours).length > 1 && productSizeId == null && Object.keys(sizes).length > 0)
                        || (Object.keys(lengths).length > 1 && productLengthId == null)
                        || (Object.keys(colours).length > 1 && productColourId == null)">
                        <option :value="null" :disabled="true">Please Select Flavour</option>
                        <option v-for="flavour in flavours" v-bind:key="flavour.id"
                            :value="flavour.id">
                            {{ flavour.name }}
                        </option>
                    </select>
                    <i class="fas fa-chevron-down"></i>
                </div>
                <div class="row" v-if="productStockWarningLevel && productId != null">
                    <div class="col">
                        <p
                            :class="'small stock-warning ' + productStockWarningLevel.colour.toLowerCase()">
                            {{ productStockWarningLevel.name }}
                        </p>
                    </div>
                </div>
                <div class="row" v-if="productRunningDown == true">
                    <div class="col mt-2">
                        <p class="small text-danger">
                            This product is currently not available for selection. Please pick a
                            different product.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                productId: null,
                productSizeId: null,
                productLengthId: null,
                productColourId: null,
                productFlavourid: null,
                productStockWarningLevel: null,
                productRunningDown: null,
                editId: null,
                sizes: [],
                lengths: [],
                colours: [],
                flavours: [],
            }
        },

        props: {
            item: {
                type: Object,
            },
            errors: {
                type: Array
            }
        },

        mounted() {
            // Set the product ids so we can use them in the select boxes
            if (this.item.product_size_id) {
                this.productSizeId = this.item.product_size_id;
            }

            if (this.item.product_length_id) {
                this.productLengthId = this.item.product_length_id;
            }

            if (this.item.product_colour_id) {
                this.productColourId = this.item.product_colour_id;
            }

            if (this.item.product_flavour_id) {
                this.productFlavourid = this.item.product_flavour_id;
            }

            if (this.item.matrix_product_id) {
                this.getBasketOptions(this.item);
            }
        },

        methods: {
            getBasketOptions(item) {
                // no context for generic items, so don't try to get options
                if (!item.school_id) {
                    return;
                }
                axios.post('/api/v1/product/basket-options',
                    {
                        'product_id': item.matrix_product_id,
                        'school_id': item.school_id,
                        'product_size_id': this.productSizeId,
                        'product_length_id': this.productLengthId,
                        'product_colour_id': this.productColourId,
                        'product_flavour_id': this.productFlavourid,
                    }
                )
                    .then(res => {
                        if (res.data && res.data.success) {

                            // Don't allow selection if the product is running down and out of stock.
                            if (res.data.running_down == true && res.data.out_of_stock == true) {
                                this.productRunningDown = true;
                                return;
                            }

                            this.productId = res.data.product_id;
                            this.editId = item.id;
                            this.sizes = res.data.sizes;
                            this.lengths = res.data.lengths;
                            this.colours = res.data.colours;
                            this.flavours = res.data.flavours;
                            this.productStockWarningLevel = res.data.stock_warning_level;
                            this.productRunningDown = false;

                            // Call the update method if the product ID is not null.
                            if (this.productId !== null) {
                                this.updateProduct();
                            }
                        }
                    })
                    .catch(err => {
                        if (err.response && err.response.status === 422) {
                            this.editId = null;
                            this.sizes = [];
                            this.lengths = [];
                            this.colours = [];
                            this.flavours = [];
                            for (const error in err.response.data.errors) {
                                this.errors[error.split('.')[0]] = err.response.data.errors[error];
                            }
                        }
                    })
                    .finally(() => {
                    });
            },

            updateProduct() {
                axios.post('/api/v1/basket/update-product', {
                    'basket_item_id': this.editId,
                    'product_id': this.productId,
                }).then((res) => {
                    if (res.data && res.data.success) {
                        this.$root.basket = res.data.basket;
                    }
                }).catch((err) => {
                    if (err.response && err.response.status === 422) {
                        for (const error in err.response.data.errors) {
                            this.errors[error.split('.')[0]] = err.response.data.errors[error];
                        }
                    }
                }).finally(() => {
                    // this.loading = false;
                    this.editId = null;
                })
            },

            personalisationChanged: _.debounce(function () {
                this.updateBasket()
            },  300),

            updateBasket() {
                this.$parent.updateBasket();
            }
        },
    }
</script>
